module.exports = __webpack_public_path__ + "static/media/lg-cirque-du-celeste-1.112f3a14.jpg";